module.exports = __webpack_public_path__ + "img/user-full.0a919c71.jpg";